import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import Home from "./Components/Home/Home";
import Headbar from "./Components/Headbar/Headbar";
import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setApi } from "./Redux/Actions";
import Women from "./Components/Women/Women";
import Productslist from "./Components/Productslist/Productslist";
import Men from "./Components/Men/Men";
import FaceandBody from "./Components/FaceandBody/FaceandBody";
import Productsdetails from "./Components/Productsdetails/Productsdetails";
import Footer from "./Components/Footer/Footer";
import Contact from "./Components/Contact/Contact";

function App() {
  const [apiData, setApiData] = useState([]);
  const data = useSelector((state) => state.setData);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const result = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/categories/list",
        params: { country: "US", lang: "en-US" },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });
      localStorage.setItem("list", JSON.stringify(result.data.brands));
      // setApiData(result.data.brands);
    })();
  }, []);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("list"))) {
      console.log("im here22");
    } else {
      dispatch(setApi(apiData));
      localStorage.setItem("list", JSON.stringify(apiData));
      setApiData(JSON.parse(localStorage.getItem("list")));
    }
  }, [apiData]);

  return (
    <BrowserRouter>
      <Headbar />
      <Navbar />
      <Route exact path="/" component={Home} />
      <Route exact path="/women" component={Women} />
      <Route path="/products/:id" component={Productslist} />
      <Route path="/details/:id" component={Productsdetails} />
      <Route exact path="/men" component={Men} />
      <Route exact path="/care-products" component={FaceandBody} />
      <Route path="/care" component={FaceandBody} />
      <Route path="/contact" component={Contact} />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
